<template>
  <form-section
    :title="$t('Audiences_Segment_Title_ShareTo')"
    :description="$t('Audiences_Segment_Title_ShareTo_Description')"
    v-loading="loading"
  >
    <template slot="controls">
      <el-button icon="ico icon-floppy" type="primary" @click="save">
        {{ $t('Button_Save') }}
      </el-button>
    </template>

    <el-row v-if="!loading">
      <el-col :span="12">
        <el-table
          class="table"
          :data="availableProjects"
          :empty-text="$t('Audiences_Segment_Text_NoProjects')"
          stripe
        >
          <el-table-column :label="$t('Audiences_Segment_Label_Projects')">
            <template slot-scope="scope">
              <checkbox
                :label="scope.row.name"
                :title="scope.row.name"
                v-model="availableProjects[scope.$index].shared"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row v-if="segmentShareAmount > 0">
      <el-col :span="12">
        <span class="shared-with-text">
          {{
            $t('Audiences_Segment_Text_SharedWidth', {
              number: segmentShareAmount
            })
          }}
        </span>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import { isEqual } from 'lodash'
import FormSection from '@/common/components/form/FormSection'
import Checkbox from '@/common/components/form/Checkbox'
import iframeLeaveConfirmationMixin from '@/common/mixins/iframeLeaveConfirmationMixin'
export default {
  name: 'SegmentTabSharing',
  mixins: [iframeLeaveConfirmationMixin],
  components: {
    FormSection,
    Checkbox
  },
  data() {
    return {
      loading: true,
      segmentsData: {},
      initialOptions: {},
      availableProjects: []
    }
  },
  created() {
    RestApi(this.fetchEndpoint)
      .then(({ data }) => {
        this.segmentsData = { ...data }

        RestApi({
          method: 'get',
          url: 'projects',
          params: {
            sort: 'title',
            company_id: this.$store.state.app.project.company.id
          }
        })
          .then(({ data }) => {
            this.availableProjects = this.prepareAvailableProjects(data)
            this.loading = false
            this.initOptions()
          })
          .catch(() => {
            this.loading = false
          })
      })
      .catch(() => {
        this.loading = false
      })
  },
  beforeRouteLeave(to, from, next) {
    if (this.confirmedViaPostMessage) {
      this.confirmedViaPostMessage = false
      return next()
    }
    if (!this.optionsHaveChanged) {
      return next()
    }
    return this.discardChangesConfirm()
      .then(() => {
        return next()
      })
      .catch(() => {
        return next(false)
      })
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'shared-segments/owner?segment_id=' + this.segmentId
      })
    },
    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: 'shared-segments/owner/sync'
      })
    },
    segmentId() {
      return this.$route.query.id
    },
    projectId() {
      return this.$route.query.project_id
    },
    optionsHaveChanged() {
      return !isEqual(this.initialOptions, this.availableProjects)
    },
    segmentShareAmount() {
      if (this.segmentsData.shared_segments) {
        return (
          this.segmentsData.total_shared_segments_count -
          this.segmentsData.shared_segments.length
        )
      } else {
        return 0
      }
    }
  },
  methods: {
    discardChangesConfirm() {
      return this.$msgbox({
        title: this.$t('RestList_DiscardChangesTitle'),
        message: this.$t('RestList_DiscardChangesPrompt'),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_DiscardChangesConfirmButton'),
        cancelButtonText: this.$t('RestList_DiscardChangesCancelButton'),
        center: true
      })
    },

    confirmLeave() {
      if (!this.optionsHaveChanged) {
        return Promise.resolve()
      }

      return this.discardChangesConfirm()
    },

    save() {
      this.loading = true
      RestApi({
        ...this.saveEndpoint,
        ...{
          data: {
            segment_id: parseInt(this.segmentId),
            shared_project_id: this.availableProjects
              .filter(project => project.shared === 1)
              .map(element => element.id)
          }
        }
      })
        .then(() => {
          this.initOptions()
          this.loading = false
          this.$message({
            message: this.$t('Audiences_Segment_Message_SharedSuccess'),
            type: 'success'
          })
        })
        .catch(error => {
          this.loading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    findSharedProject(id) {
      if (this.segmentsData.shared_segments) {
        const index = this.segmentsData.shared_segments.findIndex(
          el =>
            el.shared_project_id === id &&
            el.segment_id === parseInt(this.segmentId)
        )
        if (index === -1) {
          return 0
        } else {
          return 1
        }
      }
    },
    initOptions() {
      this.initialOptions = JSON.parse(JSON.stringify(this.availableProjects))
    },
    prepareAvailableProjects(projects) {
      if (!this.segmentsData.shared_segments) {
        return []
      }
      return projects
        .map(project => {
          return {
            id: project.id,
            name: project.name,
            shared: this.findSharedProject(project.id),
            company: project.company.name
          }
        })
        .filter(project => project.id !== parseInt(this.projectId))
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  border: 1px solid #dbdee7;
  border-radius: 4px;
  /deep/ .el-table__empty-text {
    width: 100%;
  }
}

.icon {
  color: #a7acba;
  font-size: 20px;
  float: left;
  padding: 4px 15px 0 5px;
}

.shared-with-text {
  display: inline-block;
  color: #7e8596;
  margin-top: 14px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SegmentTabSharing.vue